import { render } from "./jt.vue?vue&type=template&id=2f8ac932"
import script from "./jt.vue?vue&type=script&lang=js"
export * from "./jt.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\item\\jts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__